import React, { useContext, useEffect, useRef } from 'react';
import { ChalanUpdateAndReturnContext } from '../ChalanUpdateAndReturnComponent';
import { useForm } from 'react-hook-form';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Regex from '../../../Utilities/Regex';
import ButtonLoader from '../../CommonComponent/ButtonLoader/ButtonLoader';
import Parse from '../../../Utilities/parse';
import { useDispatch } from 'react-redux';
import CommonLoader from '../../../Utilities/CommonLoader';
import { changePurItemCostAction } from '../../../Redux/Action/PurAction';
import FieldToText from '../../../Utilities/FieldToText';
import NumberSeparator from '../../../Utilities/NumberSeparator';
import CommonStoreDropdown from '../../CommonComponent/CommonStoreDropdown/CommonStoreDropdown';

function ChalanItemCostChangeForm(props) {
  // hooks
  const dispatch = useDispatch();
  const costChangeBtnRef = useRef();

  // getting data from context
  const { singleChalanItemForReturn, singleChalanForUpdate, setNewOnClickState, chalanGetForUdpateAndReturnOnSubmit, chalanGetFieldRef } = useContext(ChalanUpdateAndReturnContext);
  // hook form property
  const {
    control,
    register,
    handleSubmit,
    getValues,
    resetField,
    setValue,
    formState: { errors },
  } = useForm();

  // set default value lifecycle
  useEffect(() => {
    setValue('totalQty', NumberSeparator.format(Parse.toNumber(singleChalanItemForReturn.total_qty_in_stock_unit), '', 3));
    setValue('unit_pur_price', singleChalanItemForReturn.unit_pur_price);
    setValue('item_cost_after_change', singleChalanItemForReturn.total_pur_price || 0);
    setValue('reference_sale_price', Parse.toNumber(singleChalanItemForReturn.reference_sale_price));
    setValue('remark', '');
    setValue('product_style', singleChalanItemForReturn.product_style);
    setValue('store_detail', singleChalanItemForReturn?.cfg_store || null);

    // set comma
    setComma();
  }, [singleChalanItemForReturn, singleChalanForUpdate]);

  // unit price on chage
  const unitPriceOnChange = () => {
    let totalPrice = Parse.toNumber(getValues('unit_pur_price')) * Parse.toNumber(getValues('totalQty'));
    setValue('item_cost_after_change', totalPrice.toFixed(2));
  };
  const totalPriceOnChange = () => {
    let unitPrice = Parse.toNumber(getValues('item_cost_after_change')) / Parse.toNumber(getValues('totalQty'));
    setValue('unit_pur_price', unitPrice.toFixed(2));
  };

  // set comma
  const setComma = () => {
    let idForSetComma = ['item_cost_after_change', 'totalQty', 'unit_pur_price'];
    // set comma
    idForSetComma.map((id) => {
      FieldToText.set([[id, getValues(id)]]);
    });
  };

  // form submit
  const onSubmit = async (data) => {
    // making payload for change item cost
    const payload = {
      data: {
        chalan_no: singleChalanForUpdate.chalan_no,
        chalan_id: singleChalanForUpdate.id,
        chalan_item_id: singleChalanItemForReturn.id,
        product_style: data.product_style,
        item_cost_after_change: data.item_cost_after_change,
        reference_sale_price: Parse.toNumber(data.reference_sale_price),
        remark: data.remark,
        store_id: singleChalanForUpdate?.is_stocked == 0 ? getValues('store_detail')?.id || null : singleChalanItemForReturn?.store_id,
      },
      costChangeBtnRef,
      chalanGetFieldRef,
      setNewOnClickState,
      chalanGetForUdpateAndReturnOnSubmit,
    };

    // action dispatch
    dispatch(changePurItemCostAction(payload));
  };

  return (
    <>
      <Form
        onChange={(e) => setComma()}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Row>
          <Col md={4}>
            {/*Product Name with style*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Product name</Form.Label>
              <Form.Control
                defaultValue={singleChalanItemForReturn.cfg_product?.product_name || ''}
                disabled={true}
                type="text"
                placeholder="product name"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            {/*category*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Category</Form.Label>
              <Form.Control
                defaultValue={singleChalanItemForReturn.cfg_product?.cfg_category?.category_name || ''}
                disabled={true}
                type="text"
                placeholder="category"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            {/*product style*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Product style</Form.Label>
              <Form.Control
                autocomplete={'off'}
                type="text"
                placeholder="Enter product style"
                className={errors.product_style ? 'is-invalid' : ''}
                {...register('product_style', {
                  required: false,
                })}
              />
              {/*validation message*/}
              {errors.product_style && <span className="text-danger">{errors.product_style.type == 'required' && 'This field is required.'}</span>}
            </Form.Group>
          </Col>
          <Col md={4}>
            {/*unit return price*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Unit purchase price</Form.Label>
              <span className="text-danger">&nbsp; {singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name && 'in ' + singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name}</span>
              <Form.Control
                autocomplete={'off'}
                type="text"
                placeholder="unit purchase price"
                className={errors.unit_pur_price ? 'is-invalid' : ''}
                {...register('unit_pur_price', {
                  required: true,
                  min: 0,
                  pattern: Regex.numeric(),
                  onChange: (event) => {
                    unitPriceOnChange();
                  },
                })}
              />
              {/*validation message*/}
              {errors.unit_pur_price && (
                <span className="text-danger">
                  {errors.unit_pur_price.type == 'required' && 'This field is required.'}
                  {errors.unit_pur_price.type == 'pattern' && 'Please provide a valid number'}
                  {errors.unit_pur_price.type == 'min' && 'Please provide a possitive number'}
                </span>
              )}
              {/*comma*/}
              {FieldToText.get('unit_pur_price')}
            </Form.Group>
          </Col>

          <Col md={4}>
            {/*Total qty*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Total Qty</Form.Label>
              <span className="text-danger">&nbsp; {singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name && 'in ' + singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name}</span>
              <Form.Control
                disabled={true}
                type="text"
                placeholder="total qty"
                className={errors.totalQty ? 'is-invalid' : ''}
                {...register('totalQty', {
                  required: true,
                  pattern: Regex.numeric(),
                })}
              />
              {/*validation message*/}
              {errors.totalQty && (
                <span className="text-danger">
                  {errors.totalQty.type == 'required' && 'This field is required.'}
                  {errors.totalQty.type == 'pattern' && 'Please provide a valid number'}
                </span>
              )}
              {/*comma*/}
              {FieldToText.get('totalQty')}
            </Form.Group>
          </Col>

          <Col md={4}>
            {/*Total return price*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Total price</Form.Label>
              <Form.Control
                autocomplete={'off'}
                type="text"
                placeholder="total price"
                className={errors.item_cost_after_change ? 'is-invalid' : ''}
                {...register('item_cost_after_change', {
                  required: true,
                  min: 0,
                  pattern: Regex.numeric(),
                  onChange: (event) => {
                    totalPriceOnChange();
                  },
                })}
              />
              {/*validation message*/}
              {errors.item_cost_after_change && (
                <span className="text-danger">
                  {errors.item_cost_after_change.type == 'required' && 'This field is required.'}
                  {errors.item_cost_after_change.type == 'pattern' && 'Please provide a valid number'}
                  {errors.item_cost_after_change.type == 'min' && 'Please provide a possitive number'}
                </span>
              )}
              {/*comma*/}
              {FieldToText.get('item_cost_after_change')}
            </Form.Group>
          </Col>

          <Col md={4}>
            {/*sale price*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Sale price</Form.Label>
              <span className="text-danger">&nbsp; {singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name && 'in ' + singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name}</span>
              <Form.Control
                autocomplete={'off'}
                type="text"
                placeholder="Sale price"
                // className={errors.item_cost_after_change ? "is-invalid" : ""}
                {...register('reference_sale_price', {
                  required: false,
                  min: 0,
                  pattern: Regex.numeric(),
                })}
              />
              {/*validation message*/}
              {errors.reference_sale_price && (
                <span className="text-danger">
                  {errors.reference_sale_price.type == 'pattern' && 'Please provide a valid number'}
                  {errors.reference_sale_price.type == 'min' && 'Please provide a possitive number'}
                </span>
              )}
            </Form.Group>
          </Col>

          {singleChalanForUpdate?.is_stocked == 0 && (
            <Col md={8}>
              <CommonStoreDropdown
                control={control}
                isRequired={true}
              />
            </Col>
          )}

          <Col md={12}>
            {/*Remark*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder={'why you want to change cost?'}
                as="textarea"
                rows={4}
                className={errors.remark ? 'is-invalid' : ''}
                {...register('remark', {
                  required: true,
                })}
              />
              {/*validation message*/}
              {errors.remark && <span className="text-danger">{errors.remark.type == 'required' && 'This field is required.'}</span>}
            </Form.Group>
          </Col>
        </Row>

        <div className="">
          <Button
            ref={costChangeBtnRef}
            variant="success"
            disabled={false}
            className="mt-2 "
            type="submit"
          >
            Change
            <ButtonLoader />
          </Button>
        </div>
      </Form>
    </>
  );
}

export default ChalanItemCostChangeForm;
